export default function GetSelectedProductIds(wlId) {
  var $checkBoxes = $(".profile-product-group .check-product[data-product-wl-id='" + wlId + "']:checked");

  var productIds = [];
  for (var i = 0, l = $checkBoxes.length; i < l; i++) {
    var item = $($checkBoxes[i]);
    var productIdentifier = item.data('productidentifier');
    productIds.push(productIdentifier);
  }
  return productIds;
}